import { render, staticRenderFns } from "./GiveFreeMonth.vue?vue&type=template&id=338f6de9&"
import script from "./GiveFreeMonth.vue?vue&type=script&lang=js&"
export * from "./GiveFreeMonth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports